import Snackbar from '@mui/material/Snackbar';
import styled from 'styled-components';

const AlertBar = styled(Snackbar).attrs({
  anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
  autoHideDuration: 6000,
  open: true,
})``;

export default AlertBar;
